export const mapCityNameByKey = (cities, key) => {
  const city = cities.find((city) => Number(city.Id) == Number(key));
  return city ? city.Name : null;
};
